/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Save_Group_FailedInputs */

const en_team_manager_save_group_failed = /** @type {(inputs: Team_Manager_Save_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error saving group. ${i?.error}`)
};

const fr_team_manager_save_group_failed = /** @type {(inputs: Team_Manager_Save_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de l’enregistrement du groupe. ${i?.error}`)
};

const de_team_manager_save_group_failed = /** @type {(inputs: Team_Manager_Save_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Speichern der Gruppe. ${i?.error}`)
};

const it_team_manager_save_group_failed = /** @type {(inputs: Team_Manager_Save_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante il salvataggio del gruppo. ${i?.error}`)
};

const ru_team_manager_save_group_failed = /** @type {(inputs: Team_Manager_Save_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка сохранения группы. ${i?.error}`)
};

const es_team_manager_save_group_failed = /** @type {(inputs: Team_Manager_Save_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al guardar el grupo. ${i?.error}`)
};

const zh_cn2_team_manager_save_group_failed = /** @type {(inputs: Team_Manager_Save_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`保存组时出错。${i?.error}`)
};

const ja_team_manager_save_group_failed = /** @type {(inputs: Team_Manager_Save_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`グループの保存中にエラーが発生しました。${i?.error}`)
};

const hi_team_manager_save_group_failed = /** @type {(inputs: Team_Manager_Save_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`समूह को सहेजने में त्रुटि। ${i?.error}`)
};

const pt_pt2_team_manager_save_group_failed = /** @type {(inputs: Team_Manager_Save_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao salvar o grupo. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error saving group. {error}" |
*
* @param {Team_Manager_Save_Group_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_group_failed = /** @type {((inputs: Team_Manager_Save_Group_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_Group_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_save_group_failed(inputs)
	if (locale === "de") return de_team_manager_save_group_failed(inputs)
	if (locale === "it") return it_team_manager_save_group_failed(inputs)
	if (locale === "ru") return ru_team_manager_save_group_failed(inputs)
	if (locale === "es") return es_team_manager_save_group_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_save_group_failed(inputs)
	if (locale === "ja") return ja_team_manager_save_group_failed(inputs)
	if (locale === "hi") return hi_team_manager_save_group_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_save_group_failed(inputs)
	return en_team_manager_save_group_failed(inputs)
});